export type PermissionFormModel = PermissionModel & {
  parentPath: string;
};

export type PayloadRequestMutationModel = Omit<PermissionFormModel, 'parentPath' | 'children'>;

export enum FormActionTypeEnum {
  ADD = 'add',
  UPDATE = 'update',
}

export interface PermissionModel {
  id?: number;
  code: string;
  name: string;
  dependenciesApiPermissions?: Array<string>;
  children?: PermissionModel[];
}

export type RecordPermissionObjectModel = Omit<PermissionModel, 'children'> & {
  children?: RecordPermissionModel;
};

export interface RecordPermissionModel {
  [key: string]: RecordPermissionObjectModel;
}

export interface StateDialogModel {
  actionType: FormActionTypeEnum;
  open: boolean;
  defaultValues: PermissionFormModel;
}
